import React, { useState, useEffect } from 'react';
import { getWinnerInfo, getRunnerOddsByMarketId } from "../../../../service/backend-api-service"
import { Button } from 'react-bootstrap';
const OddResultCell = (props) => {
    const [winner, setWinner] = useState('-')



    useEffect(() => {
        const fetchData = async () => {
            let marketId = props.marketId;
            let selectionId = props.selectionId;
            let date = props.date;
            let time = props.time;
            let winnerInfo = await getWinnerInfo(marketId, date, time)
            if (winnerInfo && winnerInfo.winner) {
                //Match finished Find Winner/Place/Loser
                if (winnerInfo.winner === selectionId) {
                    setWinner('W')
                } else if (winnerInfo.places.includes(selectionId)) {
                    setWinner('P')
                } else {
                    let odds = await getRunnerOddsByMarketId(marketId, selectionId, date)
                    if (odds.status === 'REMOVED') {
                        setWinner('NR')
                    } else {
                        setWinner('L')
                    }

                }
            }
        }
        fetchData();
        //const interval = setInterval(() => { fetchData() }, 60000);
        //return () => clearInterval(interval);
    }, [props.marketId, props.selectionId, props.date])

    let contentBody = null

    if (winner === 'W') {
        contentBody = <Button size="sm" variant="success">W</Button>
    } else if (winner === 'L') {
        contentBody = <Button size="sm" variant="danger">L</Button>
    } else if (winner === 'P') {
        contentBody = <Button size="sm" variant="warning">P</Button>
    } else {
        contentBody = <Button size="sm" variant="info">-</Button>
    }


    return (
        <>
            {winner}
        </>
    )
}

export default OddResultCell;